(function () {
  function initCounter(root) {
    if (!root || root.__comfyCounterInit) return;
    root.__comfyCounterInit = true;

    const el = root.querySelector('.comfy-counter__number');
    if (!el) return;

    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const target = Number(el.dataset.target || '0');
    const duration = Math.max(300, Number(el.dataset.duration || '1600'));
    const fmt = new Intl.NumberFormat(undefined);

    // Accessibility: if the user has "Reduce Motion" enabled in their OS/browser skip the counting animation and display the final number immediately.
    if (prefersReduced) {
      el.textContent = fmt.format(target);
      return;
    }

    // Start at 0
    el.textContent = fmt.format(0);

    const start = performance.now();
    const startVal = 0;
    const endVal = target;
    const easeOutQuad = (t) => t * (2 - t);

    function frame(now) {
      const elapsed = now - start;
      const t = Math.min(1, elapsed / duration);
      const eased = easeOutQuad(t);
      const val = Math.floor(startVal + (endVal - startVal) * eased);
      el.textContent = fmt.format(val);

      if (t < 1) {
        requestAnimationFrame(frame);
      } else {
        el.textContent = fmt.format(endVal);
      }
    }

    requestAnimationFrame(frame);
  }

  function initAll() {
    document.querySelectorAll('[data-comfy-counter]').forEach(initCounter);
  }

  // Run on first paint
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  window.addEventListener('pageshow', function (evt) {
    if (evt.persisted) initAll();
  });
})();

